// extracted by mini-css-extract-plugin
module.exports = {"container":"feedHeader__container__D9f","title":"feedHeader__title__1fV","bounceIn":"feedHeader__bounceIn__1Ew","highlightWallMessage":"feedHeader__highlightWallMessage__3dp"};